import ActionTypes from '../Actions/ActionTypes';

let initialState = {
    AllPhotos: [],

    Album: [],
    AlbumPagination: null,

    MyPhotosList: [],
    MyPhotosListPagination: null,

    eventGalleryCategories: []
};

const PhotosReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.GET_ALL_PHOTOS:
            let allPhotosCopy = [];
            allPhotosCopy = [...state.AllPhotos, ...action.payload];
            state = { ...state, AllPhotos: allPhotosCopy };
            break;

        case ActionTypes.CLEAR_ALL_PHOTOS:
            state = { ...state, AllPhotos: [] };
            break;
        
        case ActionTypes.GET_EVENT_GALLERY_CATEGORIES:
            // let eventGalleryCategoriesCopy = [];
            // eventGalleryCategoriesCopy = [...state.eventGalleryCategories, ...action.payload];
            state = { ...state, eventGalleryCategories: action.payload };
            break;

        case ActionTypes.GET_ALBUM:
            let albumCopy = [];
            albumCopy = [...state.Album, ...action.payload?.data];
            state = { ...state, AlbumPagination: action.payload, Album: albumCopy, };
            break;

            case ActionTypes.CLEAR_ALBUM:
                state = { ...state, AlbumPagination: null, Album: [] };
                break;

        case ActionTypes.GET_MY_PHOTOS:

            let myPhotosListCopy = [];
            myPhotosListCopy = [...state.MyPhotosList, ...action.payload?.data];
            state = { ...state, MyPhotosListPagination: action.payload, MyPhotosList: myPhotosListCopy };
            break;

        case ActionTypes.CLEAR_MY_PHOTOS:
            state = { ...state, MyPhotosListPagination: null, MyPhotosList: [] };
            break;

        case ActionTypes.UPDATE_MY_PHOTOS:
            let updatedMyPhotosList = [...state.MyPhotosList, ...action.payload]
            state = { ...state, MyPhotosList: updatedMyPhotosList }
            break;


        default:
            break;
    }
    return state;
};

export default PhotosReducer;